export default __webpack_public_path__ + "static/media/crowd.17b3c5ed.svg";